<template>
  <div class="business">
    <menuBox :step="3"></menuBox>
    <div class="title-box">
      <div class="title">
        การสนับสนุนการลงทุน
      </div>
      <div class="l-title">
        รับสมัครพันธมิตร ร่วมงานกับเรา ร่วมมือกันสร้างอนาคต
      </div>
    </div>
    <div class="privacy-box">
      เรียนนักลงทุนและพันธมิตรทุกท่าน
      <br />
      ในนามของบริษัท ฟ้าใหม่มันนี่ จำกัด
      ซึ่งเป็นบริษัทนวัตกรรมที่เกิดขึ้นในภาคบริการทางการเงินของประเทศไทย
      ผมขอเชิญคุณอย่างจริงใจมาสำรวจศักยภาพในการทำงานร่วมกับเรา นับตั้งแต่ก่อตั้ง
      ฟ้าใหม่มันนี่มุ่งมั่นที่จะตอบสนองความต้องการของลูกค้าที่หลากหลายโดยการให้บริการทางการเงินที่หลากหลาย
      รวมถึงสินเชื่อส่วนบุคคลและสินเชื่อธุรกิจ การประเมินสินเชื่อ
      และการให้คำปรึกษาทางการเงิน
      ภารกิจของเราคือการเพิ่มประสิทธิภาพประสบการณ์ของลูกค้าผ่านโซลูชั่นที่เป็นนวัตกรรมในขณะเดียวกันก็มีส่วนร่วมในกิจกรรมความรับผิดชอบต่อสังคมและช่วยเหลือชุมชน
      <br />
      ด้วยการพัฒนาอย่างรวดเร็วของเทคโนโลยีทางการเงิน ฟ้าใหม่ มันนี่
      ได้สร้างจุดยืนที่มีเอกลักษณ์ในตลาด
      โมเดลธุรกิจของเราผสมผสานเทคโนโลยีขั้นสูงและข้อมูลเชิงลึกของตลาดเพื่อปรับปรุงประสิทธิภาพการบริการ
      ลดต้นทุนการดำเนินงาน และสร้างประสบการณ์ที่ดียิ่งขึ้นให้กับลูกค้า ทีม R&D
      ของเรามุ่งเน้นไปที่นวัตกรรมทางเทคโนโลยีและสำรวจเครื่องมือและบริการทางการเงินใหม่
      ๆ อย่างต่อเนื่องเพื่อให้แน่ใจว่าเราอยู่ในระดับแนวหน้าของอุตสาหกรรมเสมอ
      <br />
      เราเชื่อว่าความร่วมมือที่แข็งแกร่งคือกุญแจสู่ความสำเร็จทางธุรกิจ
      ดังนั้นเราจึงมองหานักลงทุนและพันธมิตรที่มีวิสัยทัศน์และความเชี่ยวชาญเพื่อร่วมกันขยายขอบเขตธุรกิจและเสริมสร้างความสามารถในการแข่งขันในตลาด
      เป้าหมายของเราคือการบรรลุการเติบโตของธุรกิจที่ยั่งยืนผ่านความร่วมมือแบบ
      win-win และมอบผลตอบแทนจากการลงทุนที่สำคัญแก่พันธมิตร
      <br />
      ลงทุนใน Fahmai Money
      แล้วคุณจะกลายเป็นส่วนหนึ่งของทีมงานที่สร้างสรรค์และสร้างสรรค์
      สิ่งที่เรานำเสนอไม่เพียงแต่ผลิตภัณฑ์ทางการเงินเท่านั้น
      แต่ยังเป็นประสบการณ์การบริการทางการเงินรูปแบบใหม่อีกด้วย
      กลยุทธ์การเข้าสู่ตลาดของเราคือการมุ่งเน้นไปที่ความต้องการของลูกค้าโดยการนำเสนอโซลูชั่นที่ปรับแต่งให้เหมาะกับเป้าหมายทางการเงินของพวกเขา
      ขณะเดียวกัน
      เรายังให้ความสำคัญกับความรับผิดชอบต่อสังคมและตอบแทนสังคมผ่านกิจกรรมสาธารณประโยชน์ต่างๆ
      <br />
      โอกาสในการร่วมมือรวมถึงแต่ไม่จำกัดเพียงการลงทุนทางการเงิน
      ความร่วมมือทางเทคนิค การขยายตลาด และด้านอื่นๆ
      เราหวังว่าจะได้ร่วมงานกับพันธมิตรที่มีความคิดเหมือนกันเพื่อสำรวจโอกาสทางการตลาดใหม่ๆ
      และร่วมกันส่งเสริมการพัฒนาอุตสาหกรรมบริการทางการเงิน
      <br />
      หากคุณสนใจที่จะร่วมงานกับบริษัท ฟ้าใหม่ มันนี่ จำกัด
      เราหวังเป็นอย่างยิ่งว่าจะได้ติดต่อสื่อสารกับคุณต่อไป
      โปรดติดต่อเราเพื่อให้เราสามารถให้ข้อมูลเพิ่มเติมและหารือเกี่ยวกับวิธีที่เราจะทำงานร่วมกันเพื่อให้บรรลุเป้าหมายและวิสัยทัศน์ของเรา
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    submit() {
      alert("Success");
    },
  },
};
</script>
<style lang="less" scoped>
.title-box {
  background-color: #41289a;
  width: 100%;
  height: 400px;
  overflow: hidden;
  text-align: center;
  .title {
    font-size: 64px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 120px;
  }
  .l-title {
    font-size: 32px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    margin-top: 24px;
  }
}
.privacy-box {
  padding: 100px 360px;
  font-size: 18px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  color: #333333;
  line-height: 32px;
}
</style>
